<button class="btn btn-outline-primary" id="postProcess" (click)="download()" [disabled]="inProgress || disabled">
  <fa-icon *ngIf="!inProgress" [icon]="['fas', 'download']"></fa-icon>
  <fa-icon *ngIf="inProgress" [spin]="true" [icon]="['fas', 'sync-alt']"></fa-icon>
</button>
